module.exports = __webpack_public_path__ + "officialStatic/img/dzbpDetailList1.6b9c8cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/dzbpDetailList1.png
// module id = i6W1
// module chunks = 0